<template>
  <form :ref="customizeWhitelabelFormRef" method="POST">
    <input
      type="hidden"
      name="__RequestVerificationToken"
      :value="antiforgeryToken"
    />
    <div class="row">
      <div class="column small-12">
        <p class="mbm">
          {{ unPrettierNuggets.blurb }}
        </p>
        <label for="whitelabel-text">
          <strong class="text-black">Whitelabel Text</strong>
        </label>
        <span>White-labelled Text über Bilder</span>
        <img
          :ref="whitelabelTextTooltipRef"
          class="has-tip top mls"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Whitelabel Text</strong>
            <br />
            Dies ist der Text, der als Wasserzeichen über Bildern gerendert wird, sowie das Branding für PDFs und Kundenseiten. Für beste Ergebnisse empfehlen wir, den Text auf 15 bis 25 Zeichen zu beschränken.
            <br />
            Beispiel: <em>Mein Firmenbeispiel</em>"
        />
        <input
          id="whitelabel-text"
          v-model="whiteLabelTextValue"
          type="text"
          name="Text"
        />

        <label for="whitelabel-logo-url">
          <strong class="text-black">Ihr Logo (Bild-URL)</strong>
        </label>
        <span>
          {{ unPrettierNuggets.logoBlurb }}
        </span>
        <img
          :ref="whitelabelImageTooltipRef"
          class="has-tip right"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Whitelabel Image</strong>
            <br />
            Dies ist der Link zu Ihrem Bildspeicherort für Ihr Logo. Für beste Ergebnisse empfehlen wir ein Logo mit einer Breite von 250 Pixeln und einer Höhe von 150 Pixeln.
            <br />
            Wenn Sie ein Logo auf Ihrer Website haben, das Sie verwenden möchten, klicken Sie einfach mit der rechten Maustaste auf das Bild und dann auf Eigenschaften. Sie sehen dann die URL, die Sie hier kopieren und einfügen können.
            <br />Beispiel: <em>http://www.example.com/mylogo.jpg</em>"
        />
        <input
          id="whitelabel-logo-url"
          v-model="whiteLabelImageUrlValue"
          type="text"
          name="ImageUrl"
        />
        <img
          v-if="whitelabelImageUrl"
          class="mbm"
          :src="whitelabelImageUrl"
          alt="whitelabel logo preview"
        />
      </div>
    </div>
    <div class="row align-center form-stacking form-stacking--medium">
      <div class="column small-12">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mbm" />
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button primary full-width"
          @click="onClickSaveDetails"
        >
          Details speichern
        </button>
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button secondary hollow full-width"
          @click="onClickSaveDetailsAndPreviewPdf"
        >
          Abspeichern & PDF-Vorschau
        </button>
      </div>
      <div class="column medium-12 large-shrink">
        <button
          class="button secondary hollow full-width mbn"
          @click="onClickSaveDetailsAndPreviewClientPortal"
        >
          Abspeichern & Vorschau des Kundenportal
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    questionIconUrl: {
      type: String,
      default: '',
    },
    whitelabelText: {
      type: String,
      default: undefined,
    },
    whitelabelImageUrl: {
      type: String,
      default: undefined,
    },
    saveDetailsApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewPdfApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewClientPortalApi: {
      type: String,
      default: undefined,
    },
    antiforgeryToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      customizeWhitelabelFormRef: 'js-customize-whitelabel-form',
      whiteLabelTextValue: this.whitelabelText,
      whiteLabelImageUrlValue: this.whitelabelImageUrl,
      whitelabelTextTooltip: null,
      whitelabelImageTooltip: null,
      whitelabelTextTooltipRef: 'js-whitelabel-text-tooltip',
      whitelabelImageTooltipRef: 'js-whitelabel-image-tooltip',
      unPrettierNuggets: {
        blurb: `Auf dieser Seite haben Sie die Möglichkeit, das Branding des Kundenportals und der PDFs anzupassen, die generiert werden, wenn Sie sie mit Ihren Kunden teilen. Auf diese Weise können Sie die generierte Ausgabe wie Ihre eigene aussehen lassen.`,
        logoBlurb: `Bild, das als Ihr Logo auf dem Portal und im PDF angezeigt wird (empfohlene Größe: Breite 300 Pixel und Höhe 100 Pixel)`,
      },
    };
  },
  mounted() {
    if (window.Foundation && window.$) {
      this.whitelabelTextTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelTextTooltipRef]),
      );

      this.whitelabelImageTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelImageTooltipRef]),
      );
    }
  },
  methods: {
    onClickSaveDetails(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action = this.saveDetailsApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewPdf(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewPdfApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewClientPortal(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewClientPortalApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
  },
};
</script>
